import NoScheduleIcon from "Assets/Icons/NoScheduleIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import { useNavigate } from "react-router-dom";
import { Card } from "reactstrap";
import { useContext } from "react";
import { UserInfoContext } from "Context/CommonContext";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import ScheduledLectureCard from "utilFunctions/shared/ScheduledLectureCard";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";

interface TodayScheduledLectureMainIF {
  scheduleData: any;
  handleMarkSyllbus: any;
  dateRanges: any;
}
const StyledDiv: any = styled<any>("div")`
  display: flex;
  flex-direction: row;
  overflow: auto;
  width: 100%;
  gap: 12px;
`;
const TodayScheduledLectureMain = ({
  scheduleData,
  handleMarkSyllbus,
  dateRanges,
}: TodayScheduledLectureMainIF) => {
  const userInfo = useContext<any>(UserInfoContext);
  const navigate = useNavigate();
  const { screen } = useWindowSize();
  return (
    <Card
      className="p-3"
      style={{
        marginBottom: "16px",
      }}
    >
      <div className="d-flex justify-content-between pb-3">
        <Typography
          variant={["xs", "sm", "md"].includes(screen) ? "h6" : "h6F"}
          color="black"
        >
          {"Today’s Schedule"}
        </Typography>
        <span
          className="filterSpan"
          onClick={() => {
            pushToDataLayerForGTM({
              event: "ag_home_screen_dashboard_view_schedule_clicked",
              USER_ROLE: userInfo?.fexRole || "",
              EMPLOYEE_ID: userInfo?.employeeId || "",
            });
            navigate("/admin/schedule", {
              replace: false,
              state: {
                isTodaySchedule: true,
                dateRanges: dateRanges,
              },
            });
          }}
        >
          View Schedule
        </span>
      </div>

      {scheduleData && scheduleData.length > 0 ? (
        <StyledDiv>
          {scheduleData.map((item: any, index: any) => {
            return (
              <ScheduledLectureCard
                totalCards={scheduleData.length}
                key={index}
                cardData={item}
                screen={screen}
                cardIndex={index}
                handleMarkSyllbus={handleMarkSyllbus}
                mode="dashboard"
                buttonCSS={
                  scheduleData.length > 1
                    ? "scheduledButton"
                    : ["xs", "sm", "md"].includes(screen)
                    ? "scheduledButton"
                    : ""
                }
              />
            );
          })}
        </StyledDiv>
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <NoResultFoundSearch
            primaryMessage="😊 Your schedule is empty"
            secondaryMessage={"There are no lectures scheduled for you today"}
            divClassName={"noDataFound"}
          >
            <NoScheduleIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </Card>
  );
};
export default TodayScheduledLectureMain;
